import { Textarea } from "@shared/components/ui/textarea"
import { Label } from "@shared/components/ui/label"
import { cn } from "@shared/lib/utils"

export interface FormTextareaProps {
  label?: string
  value: string
  placeholder?: string
  required?: boolean
  description?: string
  onChange: (value: string) => void
  className?: string
  rows?: number
  id?: string
}

export function FormTextarea({
  label,
  value,
  placeholder,
  required = false,
  description,
  onChange,
  className,
  rows,
  id
}: FormTextareaProps) {
  const textareaId = id || (label ? `textarea-${label.toLowerCase().replace(/\s+/g, '-')}` : undefined)
  return (
    <div className="space-y-1.5">
      {(label || description) && (
        <div>
          {label && (
            <Label htmlFor={textareaId} className="text-sm text-foreground font-normal">
              {label}
              {required && <span className="text-destructive ml-0.5">*</span>}
            </Label>
          )}
          {description && (
            <p className="text-xs text-muted-foreground opacity-60 font-normal leading-tight">
              {description}
            </p>
          )}
        </div>
      )}
      <Textarea
        id={textareaId}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={cn("h-24 resize-none", className)}
        rows={rows}
        required={required}
      />
    </div>
  )
}
